import type { SVGProps } from "react";
export interface MoneyChequeEditIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function MoneyChequeEditIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: MoneyChequeEditIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 8.393V8c0-1.036-.84-1.875-1.875-1.875H5c-1.036 0-1.875.84-1.875 1.875v8c0 1.035.84 1.875 1.875 1.875h4.213l.116.005a1.125 1.125 0 0 1 0 2.239l-.116.006H5a4.125 4.125 0 0 1-4.125-4.126V8A4.125 4.125 0 0 1 5 3.875h14A4.125 4.125 0 0 1 23.125 8v.393a1.125 1.125 0 0 1-2.25 0"
      />
      <path
        fill={color}
        d="M18.09 11.645a2.626 2.626 0 0 1 3.711 0l.554.553.18.2a2.626 2.626 0 0 1-.18 3.514l-4.749 4.749a4.13 4.13 0 0 1-2.24 1.152l-1.778.296a1.476 1.476 0 0 1-1.698-1.697l.297-1.779a4.13 4.13 0 0 1 1.152-2.238l4.75-4.75Zm-3.16 6.34a1.9 1.9 0 0 0-.494.875l-.03.144-.118.706.71-.117c.384-.064.74-.247 1.016-.523l2.607-2.608-1.084-1.084zm5.28-4.748a.375.375 0 0 0-.53 0l-.552.55 1.084 1.085.552-.551a.376.376 0 0 0 .049-.472l-.049-.059zM15 8.875a1.125 1.125 0 0 1 0 2.25h-2a1.125 1.125 0 0 1 0-2.25zm-8.203 1.403.004.051.002.006.003.003.007.01q.013.015.054.046c.134.097.401.21.854.3l.235.054c1.184.305 2.497 1.16 2.497 2.776 0 1.231-.782 2.224-1.843 2.64a1.122 1.122 0 0 1-2.219.024 2.9 2.9 0 0 1-1.714-1.608l-.072-.193-.03-.112a1.124 1.124 0 0 1 2.122-.706l.043.107.03.075a.64.64 0 0 0 .187.218c.103.078.271.155.543.155.453 0 .703-.324.703-.6 0-.096-.028-.182-.148-.289a1.4 1.4 0 0 0-.514-.268l-.262-.067c-.563-.113-1.21-.304-1.736-.687-.584-.425-.997-1.076-.996-1.937q0-.053.004-.105l.002-.003c.046-1.16.853-1.984 1.837-2.342a1.124 1.124 0 0 1 2.218-.013c.84.298 1.427.921 1.715 1.608l.073.192.03.111a1.126 1.126 0 0 1-2.123.708l-.043-.107-.03-.075a.64.64 0 0 0-.187-.22c-.103-.077-.271-.155-.543-.155a.9.9 0 0 0-.573.185c-.113.094-.13.174-.13.213z"
      />
    </svg>
  );
}
